import { useQuery } from "react-query";
import { getPlans } from "../api/plans/getPlans";

/**
 * Fetches all subscription plans which exist in Syla, including legacy plans.
 */
export const useQueryGetPlans = () => useQuery("plans", getPlans);
